import { useCallback, useMemo } from "react";
import { Chart as ChartJS } from "chart.js";
import { Line } from "react-chartjs-2";
import { useColorMode } from "../../../../../Hooks/useColorMode";
import { formatMonetaryValue } from "../../../../../Utils/formatters";
import {
  buildBaasHomeSparklineOptions,
  registerBaasHomeLineChart,
} from "./BaasHomeChartOptions";

registerBaasHomeLineChart(ChartJS);

export const BaasHomeProcessingSparkline = ({ values, currency = "BRL" }) => {
  const { isDark } = useColorMode();

  const formatTooltipValue = useCallback(
    (value) => formatMonetaryValue(value, currency, { maximumFractionDigits: 0 }),
    [currency],
  );

  const chartOptions = useMemo(
    () => buildBaasHomeSparklineOptions(isDark, formatTooltipValue),
    [isDark, formatTooltipValue],
  );

  const chartData = useMemo(
    () => ({
      labels: values.map((_, index) => index),
      datasets: [
        {
          data: values,
          borderColor: "#e7a73f",
          backgroundColor: "rgba(231, 167, 63, 0.12)",
          fill: true,
          pointBackgroundColor: "#e7a73f",
        },
      ],
    }),
    [values],
  );

  if (!values?.length) {
    return null;
  }

  return (
    <div className="h-11 w-full pt-1" aria-hidden>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};
